import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { colors } = constants;
const { textXSObj, textMObj, heading1Obj, heading5Obj } = typographyStyles;
const circular = typographyStyles.fontFamily.circular;
const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;

const greyDark = colors.ui.neutral[600];
const grey = colors.ui.neutral[400];

export const rootCss = (isCompact) => ({
  position: "relative",
  alignItems: isCompact ? "flex-start" : "center",
  display: "flex",
  flexDirection: "column",

  [mediaQuery.between(xs, md)]: {
    flexDirection: isCompact ? "column" : "row-reverse",
    justifyContent: "space-between",
  },
});

export const textContainerCss = (isCompact) => ({
  alignItems: "baseline",
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: isCompact ? "flex-start" : "space-around",
  marginTop: isCompact ? "32px" : "16px",

  [mediaQuery.between(xs, md)]: {
    flexDirection: "row",
    justifyContent: "flex-start",
  },
});

export const labelCss = (isCompact) => ({
  ...textXSObj,
  ...circular,
  color: colors.ui.neutral[400],
  fontWeight: "bold",

  letterSpacing: "1px",
  textTransform: "uppercase",

  [mediaQuery.between(xs, md)]: {
    margin: isCompact ? "0" : "20px 8px 0 0",
  },
});

export const scoreLabelCss = {
  ...textXSObj,
  ...circular,
  letterSpacing: "1px",
  textTransform: "uppercase",
  fontWeight: "bold",
  color: colors.ui.neutral[400],

  [mediaQuery.between(xs, md)]: {
    display: "none",
  },
};

export const questionCountContainerCss = (isCompact) => ({
  display: isCompact ? "flex" : undefined,
  alignItems: isCompact ? "center" : undefined,
  margin: "0",
  [mediaQuery.between(xs, md)]: {
    display: "flex",
    alignItems: "center",
  },
});

export const scoreIllustrationContainerCss = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: "0",

  [mediaQuery.between(xs, md)]: {
    position: "absolute",
    transform: "translate(-50%, 0%)",
    left: "50%",
    bottom: "0%",
  },
};

export const countContainerCss = (isCompact) => ({
  alignItems: "baseline",
  color: isCompact ? colors.ui.neutral[400] : colors.ui.neutral[600],
  display: "flex",
  justifyContent: "center",
  margin: isCompact ? "3px" : 0,
  width: "100%",
});

export const currentItemCss = (isCompact) => ({
  ...(isCompact ? textXSObj : heading1Obj),
  ...circular,
  fontWeight: "bold",
});

export const countCss = (isCompact) => ({
  ...(isCompact ? textXSObj : heading5Obj),
  ...circular,
  textTransform: isCompact ? "uppercase" : undefined,
  marginLeft: "5px",
  fontWeight: "bold",
  letterSpacing: isCompact ? "1px" : "undefined",
});

export const progressBarContainerCss = (isCompact, hasScore) => ({
  width: "100%",

  [mediaQuery.between(xs, md)]: {
    marginTop: isCompact ? "undefined" : "16px",
    maxWidth: isCompact ? "100%" : hasScore ? "25%" : "48%",
  },
});

export const readingSkillCss = {
  display: "flex",
  flexDirection: "column",
  marginTop: "30px",

  h3: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "133%",
    letterSpacing: "1px",
    color: grey,
    textTransform: "uppercase",
    margin: "0",
  },

  p: {
    ...textMObj,
    color: greyDark,
    whiteSpace: "pre-line",
    marginTop: "2px",
  },
};
